import { render, staticRenderFns } from "./detailRelevancyIssue.vue?vue&type=template&id=5b691190&scoped=true&"
import script from "./detailRelevancyIssue.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b691190",
  null
  
)

export default component.exports